import { createContext } from 'react';
import type { Folder, ReadRepliedStatus, RenterProgressStatus } from '../types/GraphqlTypes';
import type { InboxPageMobileView } from '../types/InboxPageMobileView';

type ContextProps = {
  clientTimeZone: string;
  conversationId?: string;
  daysBack?: number;
  folder: Folder;
  isByProperty: boolean;
  isTimeZoneForced: boolean;
  listingAlias?: string;
  mobileView: InboxPageMobileView;
  readRepliedStatus: ReadRepliedStatus;
  renterProgressStatus: RenterProgressStatus;
};

export const InboxPageContext = createContext<ContextProps>({} as ContextProps);
export const InboxPageContextProvider = InboxPageContext.Provider;
